import { ConstraintConfigType } from "types/ConstraintsTypes";
import { ConstraintContent } from "../ConstraintContent";

type CurrencyExposureContentProps = {
  configData: ConstraintConfigType;
};

export function CurrencyExposureContent({ configData }: CurrencyExposureContentProps) {
  return (
    <ConstraintContent
      configData={configData}
      dataKey="currency_exposure"
    />
  );
}
